<template>
    <b-modal size="lg" 
            v-model="isModal" 
            no-close-on-backdrop 
            no-close-on-esc
            hide-header
            hide-footer>
            <div class="modal-header">
                <h5 class="modal-title">주문상세 내역</h5>
                <button type="button" class="close" @click="closeModal">
                <span aria-hidden="true">&times;</span>
                </button>
            </div>
            <div class="modal-body">
                <!-- 모달 내용 -->
                <b-row>
                    <b-col sm="12">
                        <span style="font-weight: 700;"><i class="fa fa-square"></i> 주문정보</span>
                    </b-col>
                </b-row>
                <b-row class="pt-sm-2">
                    <b-col sm="12">
                        <table class="table table-bordered oddBackground">
                            <tbody>
                                <tr>
                                    <td style="width:25%">주문번호</td>
                                    <td class="tl" style="width:75%;">{{ item.order_code }}</td>
                                </tr>
                                <tr>
                                    <td style="width:25%">주문상태</td>
                                    <td class="tl" style="width:75%;">{{ item.status_name }}</td>
                                </tr>
                                <tr>
                                    <td style="width:25%">상품명</td>
                                    <td class="tl" style="width:75%;">{{ item.order_pname }}</td>
                                </tr>
                                <tr>
                                    <td style="width:25%">주문일</td>
                                    <td class="tl" style="width:75%;">{{ item.order_date }}</td>
                                </tr>
                            </tbody>
                        </table>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col sm="12">
                        <span style="font-weight: 700;"><i class="fa fa-square"></i> 주문자 정보</span>
                    </b-col>
                </b-row>
                <b-row class="pt-sm-2">
                    <b-col sm="12">
                        <table class="table table-bordered oddBackground">
                            <tbody>
                                <tr>
                                    <td style="width:25%">주문자명</td>
                                    <td class="tl" style="width:75%;">{{ item.order_name }}</td>
                                </tr>
                                <tr>
                                    <td style="width:25%">이메일</td>
                                    <td class="tl" style="width:75%;">{{ item.user_id }}</td>
                                </tr>
                                <tr>
                                    <td style="width:25%">휴대폰번호</td>
                                    <td class="tl" style="width:75%;">{{ item.order_mobile | phoneNumberRegx }}</td>
                                </tr>
                                <tr>
                                    <td style="width:25%">회사(기업)정보</td>
                                    <td class="tl" style="width:75%;">{{ item.industry_name }}</td>
                                </tr>
                                <tr>
                                    <td style="width:25%">회사(기관)명</td>
                                    <td class="tl" style="width:75%;">{{ item.company_name }}</td>
                                </tr>
                            </tbody>
                        </table>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col sm="12">
                        <span style="font-weight: 700;"><i class="fa fa-square"></i> 결제 정보</span>
                    </b-col>
                </b-row>
                <b-row class="pt-sm-2">
                    <b-col sm="12">
                        <table class="table table-bordered oddBackground">
                            <tbody>
                                <tr>
                                    <td style="width:25%">결제방식</td>
                                    <td class="tl" style="width:75%;">{{ item.pay_type_name }}</td>
                                </tr>
                                <tr>
                                    <td style="width:25%">결제금액</td>
                                    <td class="tl" style="width:75%;">{{ item.amount | numberComma }} 원</td>
                                </tr>
                                <tr>
                                    <td style="width:25%">할인금액</td>
                                    <td class="tl" style="width:75%;">{{ item.dc_price | numberComma }} 원</td>
                                </tr>
                                <tr>
                                    <td style="width:25%; vertical-align: middle;">사업자등록증</td>
                                    <td class="tl" style="width:75%;">
                                        <button v-if="item.bl_file_originalname != null && item.bl_file_originalname != ''" class="btn btn-primary btn-sm" @click="downloadFile()">다운로드</button>
                                    </td>
                                </tr>
                                <tr>
                                    <td style="width:25%">계산서 수신 이메일</td>
                                    <td class="tl" style="width:75%;">{{ item.invoice_mail }}</td>
                                </tr>
                            </tbody>
                        </table>
                    </b-col>
                </b-row>
            </div>
            <div class="modal-footer">
                <button class="btn btn-primary" @click="closeModal">확인</button>
            </div>
    </b-modal>
</template>
<script>
import { EventBus } from "../../../../../event-bus";

export default {
    name: 'userOrderDetailModal',
    props: {
        formModal: {
            type: Boolean,
        },
        item: {
            type: Object,
        }
    },
    data() {
        return {
            isModal: false,    
        }
    },
    methods: {
        closeModal(){
            EventBus.$emit('callOrderCloseModal');
        },
        // 사업자등록증 다운로드
        downloadFile(){
            var param = encodeURI(JSON.stringify(this.item));

            var data = new FormData();
            data.append('fileInfo', param);

            var config = {
                responseType: 'blob'
            };

            this.$http.post('/fileservice/blDownload', data, config).then((result) => {
                const url = window.URL.createObjectURL(new Blob([result.data]));
                    const link = document.createElement('a');
                    link.href = url;
                    link.setAttribute('download', this.item.bl_file_originalname); //or any other extension
                    document.body.appendChild(link);
                    link.click();
                })
        },
    },
    watch: {
        formModal: function (value, oldValue) {
            // console.log('====', value, oldValue);
            this.isModal=  this.formModal;
        },
    },
}
</script>
<style lang="css" scoped>
.oddBackground td:nth-child(odd) {
  background:#dcdcdc;
  font-weight: 600;
  text-align: center;
}
.theader{
  background:#dcdcdc;
  font-weight: 600;
}
.tl {
    text-align: left;
}
</style>


// WEBPACK FOOTER //
// src/views/user/userDetail/component/tabs/order/UserOrderDetailModal.vue